@for (items of tree; let idx1 = $index; track $index) {
  <div
    class="relative w-full flex flex-row justify-between items-end gap-3 lg:gap-4"
    [ngClass]="{ 'mt-3 lg:mt-6': idx1 > 0, 'mt-0': idx1 == 0 }"
  >
    <p class="text-black dark:text-white text-sm lg:text-2xl">
      {{
        idx1 == 0 ? 'Category' : selectedTree[idx1 - 1][0] ? selectedTree[idx1 - 1][0].title : ''
      }}
    </p>
    @if (idx1 > 0) {
      <button
        class="relative flex-none mx-1 lg:mx-2 px-1.5 lg:px-3 py-0.5 lg:py-1 text-[0.625rem] lg:text-base rounded text-white"
        (click)="onClickAllCheckout(idx1)"
        [ngClass]="{
          'bg-black ring-1 ring-white': !isAllCheckout(idx1 - 1, idx1),
          'bg-red-600 ring-0': isAllCheckout(idx1 - 1, idx1),
        }"
      >
        {{ !isAllCheckout(idx1 - 1, idx1) ? 'Select All' : 'Deselect All' }}
      </button>
    }
  </div>
  <div class="w-full h-[1px] lg:h-[2px] bg-white/30 my-1.5 lg:my-3"></div>
  <div class="relative w-full flex flex-row flex-wrap gap-1 lg:gap-3 rounded">
    @for (item of items; let idx2 = $index; track item.title) {
      <button
        class="relative flex-none px-1.5 lg:px-3 py-0.5 lg:py-1 text-[0.625rem] lg:text-base rounded text-white ring-offset-cyan-600 disabled:bg-slate-400 dark:disabled:bg-slate-100 disabled:text-slate-400 disabled:opacity-50"
        (click)="onClickPart(idx1, item)"
        [disabled]="!item.uuid && idx1 > 0 && item.parent != selectedTree[idx1]"
        [ngClass]="{
          'bg-sky-600 ring-0': checkSelectedTree(idx1, item),
          'bg-slate-400 dark:bg-none ring-1': !checkSelectedTree(idx1, item),
        }"
      >
        {{ item.title }}
      </button>
    }
  </div>
}
